/**
 * @param {string} value
 * @returns {string}
 */
export function normalize(value) {
  return value.toLowerCase()
}
/**
 * @param {string} value
 * @returns {string}
 */
export function normalize(value) {
  return value.toLowerCase()
}
